import axios from "axios";
import Encrypt from "../utils/encode";

// const baseURL = "http://localhost:5010/";
// const baseURL = "https://meg.quizzzmaster.com/";
const baseURL="/";

export const login = async (data) => {
    const response = await axios.post(`${baseURL}api/v1/login`, data);
    return response;
};

// APIS THAT REQUIRE ACCESS TOKEN 

export const getFunFact = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/fun-facts`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getProfile = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-user-profile`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getAllQuiz = async (language, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-all-quizes2?lang_id=${language}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    return response;
};

export const getQuiz = async (quizId, levelId, currentLanguage, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-quiz2/${quizId}/${levelId}?lang_id=${currentLanguage}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response;
}

export const getQuizDetails = async (quizId, levelId, currentLanguage, token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-quiz2/${quizId}/${levelId}?lang_id=${currentLanguage}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response?.data?.result?.data;
}

export const getLeaderboard = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-leaderboard`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const updateProfile = async (formData, token) => {
    const response = await axios.post(`${baseURL}api/v1/protected/edit-profile`, formData, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data.data;
};

export const getHistory = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/get-history?offset=0`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const getAllOpponent = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/finding-opponent`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
};

export const saveUserPoints = async (quizId, quizName, quizImage, levelId, points, totalPoints, token) => {
    const encryptPayload = Encrypt({
        quizId: quizId,
        quizName: quizName,
        quizImage: quizImage,
        levelId: levelId,
        userPoints: points,
        totalPoints: totalPoints
    })

    const response = await axios.post(`${baseURL}api/v1/protected/save-user-points`, encryptPayload, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        }
    });
    return response;

    // const response = await axios.post(`${baseURL}api/v1/protected/save-user-points`, {
    //     quizId: quizId,
    //     quizName: quizName,
    //     quizImage: quizImage,
    //     levelId: levelId,
    //     userPoints: points,
    //     totalPoints: totalPoints
    // }, {
    //     headers: {
    //         Authorization: `Bearer ${token}`
    //     }
    // });
    // return response;
};

export const checkUserSubscription = async (token) => {
    const response = await axios.get(`${baseURL}api/v1/protected/check-user-subscription`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

const Integrated_API_URL = "https://eg.quizzzmaster.com/";

export const SendOtpAPI = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/SendOTP`, {
        msisdn
    });
    return response;
}

export const VerifyOtpAPI = async (msisdn, otp) => {
    const response = await axios.post(`${Integrated_API_URL}OTP/verifyOTP`, {
        msisdn,
        otp
    });
    return response;
}

export const confirmSubAPI = async (msisdn, ext_ref, autoRenewal) => {
    const response = await axios.post(`${Integrated_API_URL}activate-user`, { msisdn, ext_ref, subscription_type: autoRenewal ? "renewal" : "ondemand" });
    return response;
}

export const unsubscribeAPI = async (msisdn) => {
    const response = await axios.post(`${Integrated_API_URL}deactivate-user`, { msisdn });
    return response;
}

export const increaseValidityApi = async (msisdn, ext_ref, subscription_type) => {
    const response = await axios.post(`${Integrated_API_URL}activate-user/increase-validity`, { msisdn, ext_ref, subscription_type });
    return response;
}